<template>
  <section class="hero-banner">
    <PrepeersImage
      v-if="props.src"
      :src="props.src"
      :alt="props.alt"
      preset="heroBg"
      image-class="hero-banner__bg-image"
      loading="lazy" />
    <PrepeersImage
      v-if="props.src"
      :src="props.src"
      :alt="props.alt"
      preset="heroFg"
      image-class="hero-banner__image"
      sizes="100vw sm:80vw lg:800px"
      loading="eager"
      :preload="{ fetchPriority: 'high' }" />
    <slot />
  </section>
</template>

<script lang="ts" setup>
import PrepeersImage from '~/components/core/PrepeersImage.vue'
import type { PrepeersHeroCoverProps } from '~/types/PrepeersHeroCover'

/**
 * Définit les props du composant PrepeersHeroCover.
 */
const props: PrepeersHeroCoverProps = defineProps({
  src: {
    type: String,
    default: '',
  },
  alt: {
    type: String,
    required: true,
  },
})
</script>
